function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16512_203453)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59841 0H11.0171L15.8003 4.78409V13.971C15.8003 15.0865 14.8877 16 13.7712 16H5.59844C4.48288 16 3.57031 15.0865 3.57031 13.971V2.02903C3.57031 0.913469 4.48288 0 5.59841 0Z",
    fill: "#378DE8",
    style: {
      fill: "#378DE8",
      fill: "color(display-p3 0.2171 0.5515 0.9106)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0195 0L15.8027 4.78409H11.5352C11.2509 4.78409 11.0195 4.55184 11.0195 4.26747V0Z",
    fill: "#1B5EBE",
    style: {
      fill: "#1B5EBE",
      fill: "color(display-p3 0.1059 0.3686 0.7451)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7987 7.55482H7.5786C7.38467 7.55482 7.22461 7.39783 7.22461 7.20392C7.22461 7.01002 7.38467 6.85303 7.5786 6.85303H11.7987C11.9926 6.85303 12.1496 7.01002 12.1496 7.20392C12.1496 7.39783 11.9926 7.55482 11.7987 7.55482ZM10.392 11.7749H7.5786C7.38467 11.7749 7.22461 11.6179 7.22461 11.424C7.22461 11.2301 7.38467 11.0731 7.5786 11.0731H10.392C10.5859 11.0731 10.7429 11.2301 10.7429 11.424C10.7429 11.6179 10.5859 11.7749 10.392 11.7749ZM11.7987 10.3682H7.5786C7.38467 10.3682 7.22461 10.2112 7.22461 10.0173C7.22461 9.82342 7.38467 9.66644 7.5786 9.66644H11.7987C11.9926 9.66644 12.1496 9.82342 12.1496 10.0173C12.1496 10.2112 11.9926 10.3682 11.7987 10.3682ZM11.7987 8.96153H7.5786C7.38467 8.96153 7.22461 8.80454 7.22461 8.61063C7.22461 8.41672 7.38467 8.25973 7.5786 8.25973H11.7987C11.9926 8.25973 12.1496 8.41672 12.1496 8.61063C12.1496 8.80454 11.9926 8.96153 11.7987 8.96153Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.64596 4.78613H3.55859V13.1703H7.64596C7.80882 13.1695 7.96481 13.1046 8.08013 12.9895C8.19544 12.8745 8.26078 12.7187 8.262 12.5558V5.40063C8.26078 5.23776 8.19544 5.08194 8.08013 4.96692C7.96481 4.8519 7.80882 4.78694 7.64596 4.78613Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.31007 5.12012H3.55859V13.5043H7.31007C7.47294 13.5035 7.62893 13.4386 7.74424 13.3235C7.85955 13.2085 7.9249 13.0527 7.92612 12.8898V5.73461C7.9249 5.57175 7.85955 5.41592 7.74424 5.3009C7.62893 5.18588 7.47294 5.12093 7.31007 5.12012Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.31007 5.12012H3.55859V12.8336H7.31007C7.47294 12.8328 7.62893 12.7678 7.74424 12.6528C7.85955 12.5378 7.9249 12.3819 7.92612 12.2191V5.73461C7.9249 5.57175 7.85955 5.41592 7.74424 5.3009C7.62893 5.18588 7.47294 5.12093 7.31007 5.12012Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.97419 5.12012H3.55859V12.8336H6.97419C7.13706 12.8328 7.29305 12.7678 7.40836 12.6528C7.52367 12.5378 7.58901 12.3819 7.59023 12.2191V5.73461C7.58901 5.57175 7.52367 5.41592 7.40836 5.3009C7.29305 5.18588 7.13706 5.12093 6.97419 5.12012Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.813311 5.12012H6.97273C7.13589 5.11998 7.29243 5.18463 7.40795 5.29986C7.52346 5.41508 7.5885 5.57146 7.58878 5.73462V11.8837C7.5885 12.0469 7.52346 12.2033 7.40795 12.3185C7.29243 12.4337 7.13589 12.4984 6.97273 12.4982H0.813311C0.732465 12.4985 0.652361 12.4828 0.577597 12.452C0.502834 12.4213 0.434882 12.376 0.377643 12.3189C0.320404 12.2618 0.275005 12.194 0.244051 12.1193C0.213097 12.0446 0.197197 11.9646 0.197266 11.8837V5.73462C0.197197 5.65377 0.213097 5.57371 0.244051 5.49902C0.275005 5.42433 0.320404 5.3565 0.377643 5.2994C0.434882 5.24231 0.502834 5.19708 0.577597 5.16631C0.652361 5.13555 0.732465 5.11985 0.813311 5.12012Z",
    fill: "#2368C4",
    style: {
      fill: "#2368C4",
      fill: "color(display-p3 0.1373 0.4078 0.7686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72245 9.83326C2.73407 9.92495 2.74185 10.0052 2.74578 10.0741C2.74601 10.0782 2.74939 10.0814 2.75349 10.0814C2.75751 10.0814 2.76086 10.0783 2.76119 10.0743C2.76658 10.0087 2.77757 9.93021 2.79416 9.83894C2.81996 9.69705 2.82615 9.66455 2.84008 9.59902L3.39233 7.21976C3.44811 6.97941 3.66226 6.80928 3.90899 6.80928C4.15348 6.80928 4.3663 6.97639 4.42427 7.21391L4.99624 9.55723C5.03456 9.72545 5.06229 9.89591 5.07928 10.0676C5.07959 10.0708 5.08225 10.0732 5.08544 10.0732C5.08868 10.0732 5.09137 10.0707 5.09162 10.0675C5.10457 9.90043 5.12769 9.73435 5.16083 9.57013L5.63959 7.10123C5.67287 6.9296 5.82315 6.80566 5.99798 6.80566C6.2334 6.80566 6.40727 7.02522 6.35333 7.25438L5.62025 10.3683C5.56026 10.6232 5.33286 10.8033 5.07106 10.8033C4.81045 10.8033 4.58374 10.6247 4.52261 10.3714L3.98859 8.15849C3.97001 8.08213 3.94903 7.98272 3.92564 7.86027C3.90299 7.74167 3.88872 7.65405 3.88285 7.5974C3.88253 7.59432 3.87994 7.59197 3.87685 7.59197C3.87379 7.59197 3.87121 7.59427 3.87087 7.59731C3.86346 7.66222 3.84921 7.75692 3.82813 7.88142C3.80646 8.00938 3.78926 8.10431 3.77653 8.16623L3.2774 10.361C3.21837 10.6206 2.98759 10.8048 2.7214 10.8048C2.45711 10.8048 2.22746 10.6232 2.16655 10.366L1.43279 7.2677C1.37737 7.0337 1.55485 6.80928 1.79532 6.80928C1.97174 6.80928 2.12397 6.93301 2.16003 7.10571L2.68169 9.6047C2.6987 9.68024 2.7123 9.7565 2.72245 9.83326Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16512_203453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.f28d2dca222d7da2240f5ff49d05be5c.svg";
export { ForwardRef as ReactComponent };